module.exports = __webpack_public_path__ + "img/ingredienten-chinese-kip-met-tomatensaus.884b638d.jpeg";